import { useEffect, useState, useContext } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import ErrorAlert from "../components/ErrorAlert";
import SuccessAlert from "../components/SuccessAlert";
import axiosInstance from "../utils/axiosInstance";
import logo from "../assets/logo.png";
import { AuthContext } from "../context/AuthContext";
import Loader from "../components/Loader";

function ActivateAccount() {
    const { background, isBackgroundLoaded } = useContext(AuthContext);
    const [searchParams] = useSearchParams();
    const token = searchParams.get("token");
    const [message, setMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        if (!token) {
            navigate("/login");
            return;
        }

        const activateAccount = async () => {
            try {
                setLoading(true);
                await axiosInstance.post("/register/activate", { token });
                setMessage("Your account has been successfully activated. Redirecting to login...");
                setErrorMessage("");
                setLoading(false);

                setTimeout(() => {
                    navigate("/login");
                }, 3000);
            } catch (err) {
                setLoading(false);
                if (err.response?.status === 400) {
                    setErrorMessage(err.response.data.message);
                } else {
                    setErrorMessage("There was a problem activating your account.");
                }
            }
        };

        activateAccount();
    }, [token, navigate]);

    return (
        <div className={`min-h-screen flex bg-white dark:bg-gray-900`}>
            {/* Left Section - Wallpaper */}
            <div className="relative w-2/3 bg-gray-700">
                {!isBackgroundLoaded ? (
                    <div className="absolute inset-0 flex items-center justify-center bg-white z-10">
                        <Loader />
                    </div>
                ) : background.type === "IMAGE" ? (
                    <div
                        className={`w-full h-full bg-cover bg-center transition-opacity duration-500 ${
                            isBackgroundLoaded ? "opacity-100" : "opacity-0"
                        }`}
                        style={{ backgroundImage: `url("${background?.url}")` }}
                    />
                ) : (
                    <video
                        className={`w-full h-full bg-cover bg-center transition-opacity duration-500 ${
                            isBackgroundLoaded ? "opacity-100" : "opacity-0"
                        }`}
                        width="600"
                        autoPlay
                        muted
                        loop
                        preload="metadata"
                    >
                        <source src={background?.url} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                )}
            </div>

            {/* Right Section */}
            <div className="w-2/3 flex items-center justify-center">
                <div className="w-full max-w-md px-8 py-10 bg-white shadow-lg rounded-lg dark:bg-gray-800">
                    {/* Logo */}
                    <div className="flex flex-col items-center mb-4">
                        <img src={logo} alt="Logo" className="w-12 h-auto mb-4" />
                        <h1 className="text-3xl font-bold text-red-600">VDP Tuning Team</h1>
                    </div>

                    {loading && <Loader />}
                    {!loading && message && <SuccessAlert message={message} />}
                    {!loading && errorMessage && <ErrorAlert errorMessage={errorMessage} />}

                    <div className="mt-4 text-center">
                        <p className="text-gray-600 dark:text-gray-400">
                            Back to{" "}
                            <a href="/login" className="text-red-600 hover:underline">
                                Login
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ActivateAccount;